import { Spinner } from '@/core/ui';

const Loading = () => {
  return (
    <div className='h-screen bg-background w-full flex-col space-y-2 flex justify-center items-center'>
      <div className='p-8 flex items-center space-x-3'>
        <img alt='logo' width={70} height={70} src='/logo.svg' />
        <h5 className='text-foreground font-medium uppercase text-4xl'>Quesmed</h5>
      </div>
      <Spinner
        classNames={{
          circle1: 'w-20 h-20 border-[6px]',
          circle2: 'w-20 h-20 border-[6px]',
        }}
      />
    </div>
  );
};

export default Loading;
